// extracted by mini-css-extract-plugin
export default {"base":"Tabs_base__w2l53","horizontal":"Tabs_horizontal__Y7Yv4","vertical":"Tabs_vertical__f+yK7"};